import React, { useEffect, useMemo, useState } from "react";
import { sendBroadcastEmail, uploadBroadCasting } from "_services";
import {
  ButtonHeading,
  CommonInput,
  CommonTextarea,
  CustomSelect,
} from "components";
import { toast } from "react-hot-toast";
import { getUserList } from "_services/userService";
import EmojiPicker from "emoji-picker-react";
import { FaSmile } from "react-icons/fa";
import { BsEmojiSmile } from "react-icons/bs";

const Brodcasting = () => {
  const getMasterData = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("masterData"));
    } catch {
      return null;
    }
  }, []);
  const getUserData = JSON.parse(localStorage.getItem("userData"));
  const obj = {
    templateId: "",
    message: "",
    birdId: "",
    title: "",
    customId: `${Date.now()}`,
  };
  const [birdStatusList, setBirdStatusList] = useState([]);
  const [userDataList, setUserDataList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formValue, setFormValue] = useState(obj);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [selectType, setSelectType] = useState("Push");

  useEffect(() => {
    const birds = getMasterData?.birds;

    if (Array.isArray(birds) && birds.length) {
      const birdList = birds.map((i) => ({
        label: i?.title,
        value: i?._id,
      }));
      setBirdStatusList([{ label: "All", value: "" }, ...birdList]);
    }
  }, [getMasterData]);

  useEffect(() => {
    if (formValue?.birdId === "" || formValue?.birdId) {
      const payload = {
        userId: getUserData._id,
        birdId: formValue?.birdId,
      };
      fetchlistUserData(payload);
    }
  }, [formValue?.birdId]);
  // }, [formValue?.birdId, selectType]);

  const fetchlistUserData = async (data) => {
    try {
      const payload = {
        userId: data?.userId,
        birdId: data?.birdId,
        // ...(selectType === "Email" && { isEmailVerified: true }),
      };
      const res = await getUserList(payload);
      if (Array.isArray(res?.data?.users) && res?.data?.users?.length) {
        const categoryList = res?.data?.users.map((i) => ({
          label: `${i?.firstName} ${i?.lastName}`,
          value: i?._id,
        }));
        setUserDataList([{ label: "All", value: 0 }, ...categoryList]);
      } else {
        toast.error(res?.responseMessage);
        setUserDataList([]);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }
  };

  const handleOnChange = (name, value) => {
    setFormValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleUpdate = async () => {
    setLoading(true);
    const payload = {
      ...formValue,
    };
    delete payload.templateId;

    try {
      const res = await uploadBroadCasting(payload);
      if (res) {
        setLoading(false);
        toast.success(res?.message);
        setFormValue(obj);
      } else {
        toast.error(res?.message);
        setLoading(false);
        setFormValue(obj);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
      setLoading(false);
      setFormValue(obj);
    }
  };

  const handleBroadCastEmail = async () => {
    setLoading(true);
    const payload = {
      ...formValue,
    };

    try {
      const res = await sendBroadcastEmail(payload);
      if (res) {
        setLoading(false);
        toast.success(res?.message);
        setFormValue(obj);
      } else {
        toast.error(res?.message);
        setLoading(false);
        setFormValue(obj);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
      setLoading(false);
      setFormValue(obj);
    }
  };

  const handleEmojiClick = (emojiObject) => {
    setFormValue((prev) => ({
      ...prev,
      message: `${prev.message}${emojiObject.emoji}`,
    }));
    setShowEmojiPicker(false);
  };

  return (
    <div>
      <ButtonHeading title={"Broadcasting"} />

      <div class="__broadCastFx ">
        <div className="d-flex gap-3 ">
          <div className="_dualCheckr_bx">
            <input
              className="form-check-input"
              id={"Push"}
              type="radio"
              name="template_type"
              value={selectType}
              checked={selectType === "Push"}
              onChange={() => setSelectType("Push")}
            />
            <label htmlFor={"Push"} className="form-check-label">
              Push
            </label>
          </div>

          <div className="_dualCheckr_bx">
            <input
              className="form-check-input"
              id={"Email"}
              type="radio"
              name="template_type"
              value={selectType}
              checked={selectType === "Email"}
              onChange={() => setSelectType("Email")}
            />
            <label htmlFor={"Email"} className="form-check-label">
              Email
            </label>
          </div>
        </div>

        {selectType === "Email" && (
          <div style={{ maxWidth: "600px" }}>
            <CommonInput
              type="text"
              placeholder="Enter Templet Id"
              label="Enter Templet Id"
              name="templateId"
              value={formValue?.templateId}
              onChange={({ target: { name, value } }) =>
                handleOnChange(name, value)
              }
            />
          </div>
        )}

        <div style={{ maxWidth: "600px" }}>
          <CommonInput
            type="text"
            placeholder="Enter Title"
            label="Enter Title"
            name="title"
            value={formValue?.title}
            onChange={({ target: { name, value } }) =>
              handleOnChange(name, value)
            }
          />
        </div>
        <div style={{ maxWidth: "600px", position: "relative" }}>
          <CommonTextarea
            label={"Enter text"}
            rows={5}
            name="message"
            value={formValue?.message}
            onChange={({ target: { name, value } }) =>
              handleOnChange(name, value)
            }
          />
          <div
            onClick={() => setShowEmojiPicker((prev) => !prev)}
            style={{
              position: "absolute",
              top: "8px",
              right: "8px",
              background: "transparent",
              border: "none",
              cursor: "pointer",
              fontSize: "20px",
              color: showEmojiPicker ? "#1956f6" : "",
            }}
          >
            <BsEmojiSmile />
          </div>
          {showEmojiPicker && (
            <div
              style={{
                position: "absolute",
                zIndex: 1000,
                top: "0px",
                right: "-60%",
              }}
            >
              <EmojiPicker
                onEmojiClick={handleEmojiClick}
                previewConfig={{ showPreview: false }}
              />
            </div>
          )}
        </div>

        <div style={{ maxWidth: "600px" }}>
          <CustomSelect
            options={birdStatusList}
            value={birdStatusList.find((i) => i.value === formValue?.birdId)}
            name="birdId"
            label="Select Bird"
            placeholder="Select Bird"
            onSelect={(data) => {
              handleOnChange("birdId", data?.value);
              handleOnChange("userId", "");
            }}
          />
        </div>
        <div style={{ maxWidth: "600px" }}>
          <CustomSelect
            key={`user-select-${formValue.userId}`}
            options={userDataList}
            value={
              userDataList.find((i) => i.value === formValue?.userId) || null
            }
            name="userId"
            label="Select User"
            placeholder="Select User"
            onSelect={(data) => handleOnChange("userId", data?.value)}
          />
        </div>
        <div className="d-flex gap-2">
          {selectType === "Push" ? (
            <button
              className="_addComm_btn"
              onClick={() => handleUpdate()}
              // disabled={loading}
            >
              Send Push Notifications
            </button>
          ) : (
            <button
              className="_addComm_btn"
              onClick={() => handleBroadCastEmail()}
              // disabled={loading}
            >
              Send Email
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Brodcasting;
